webpackJsonp([1,0],[
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _vue = __webpack_require__(12);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _App = __webpack_require__(8);
	
	var _App2 = _interopRequireDefault(_App);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	new _vue2.default({
	  el: '#app',
	  template: '<App/>',
	  components: { App: _App2.default }
	});

/***/ }),
/* 1 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var PLAY_CLASS = exports.PLAY_CLASS = 'pause';
	
	var PAUSE_CLASS = exports.PAUSE_CLASS = 'play';
	
	var LOAD_CLASS = exports.LOAD_CLASS = 'load';
	
	var SINGLE = exports.SINGLE = 0;
	
	var ORDER = exports.ORDER = 1;
	
	var LOOP = exports.LOOP = 2;
	
	var CIRCULATION = exports.CIRCULATION = 3;
	
	var RANDOM = exports.RANDOM = 4;

/***/ }),
/* 2 */,
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _audio = __webpack_require__(9);
	
	var _audio2 = _interopRequireDefault(_audio);
	
	var _constant = __webpack_require__(1);
	
	var constant = _interopRequireWildcard(_constant);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'app',
	  components: {
	    vueAudio: _audio2.default
	  },
	  data: function data() {
	    return {
	      lists: [{
	        source: 'http://file.kuyinyun.com/group2/M00/EF/C0/rBBGelUPiWiACpYhAAQfE72-jHE679.mp3',
	        time: '0:16'
	      }, {
	        source: 'http://file.kuyinyun.com/group2/M00/61/1A/rBBGelcTAZCAcQ4cAAcmErMReH4964.mp3',
	        time: '0:22'
	      }, {
	        source: 'http://file.kuyinyun.com/group1/M00/94/83/rBBGdFYkXFuAYuTRAA2ax4_NmEk387.mp3',
	        time: '0:55'
	      }, {
	        source: 'http://file.kuyinyun.com/group2/M00/84/DF/rBBGelZL7EuAKFL_ABiwByGtPBo792.mp3',
	        time: '0:33'
	      }],
	      mode: constant.SINGLE,
	      single_mode: constant.SINGLE,
	      loop_mode: constant.LOOP,
	      order_mode: constant.ORDER,
	      circulation_mode: constant.CIRCULATION,
	      random_mode: constant.RANDOM,
	      svgOptions: {
	        width: 40,
	        height: 40,
	        fill: 'none',
	        stroke: '#007aff',
	        strokeWidth: 2
	      }
	    };
	  },
	
	  methods: {
	    timeupdate: function timeupdate(e) {
	      var target = e.target;
	      var currentTime = target.currentTime;
	      var duration = target.duration;
	      var percent = (100 / duration * currentTime).toFixed(1);
	      if (isNaN(percent) || percent === '0.0') {
	        percent = 0;
	      }
	      var svg = target.parentNode.querySelector('svg');
	      if (percent > 100) {
	        percent = 100;
	      }
	      var centerX = this.svgOptions.width / 2;
	      var centerY = this.svgOptions.height / 2;
	      var radius = centerX - this.svgOptions.strokeWidth / 2;
	      var startX = centerX;
	      var startY = centerY - radius;
	      var xAxisRotation = 0;
	      var sweepFlag = 1;
	      var circ = Math.PI * 2;
	      var largeArcFlag = 0;
	      if (percent * circ / 100 >= Math.PI) {
	        largeArcFlag = 1;
	      }
	      var endX = centerX + radius * Math.sin(circ * percent / 100);
	      var endY = centerY - radius * Math.cos(circ * percent / 100);
	      var d = 'M' + startX + ',' + startY + ' ' + 'A' + radius + ',' + radius + ' ' + xAxisRotation + ' ' + largeArcFlag + ' ' + sweepFlag + ' ' + endX + ',' + endY;
	      var path = svg.querySelector('path');
	      path.setAttribute('d', d);
	    },
	    playing: function playing(e) {
	      var ele = e.path ? e.path[1] : e.target.parentElement;
	      ele.querySelector('a').className = constant.PLAY_CLASS;
	    },
	    pause: function pause(e) {
	      var ele = e.path ? e.path[1] : e.target.parentElement;
	      ele.querySelector('a').className = constant.PAUSE_CLASS;
	    },
	    ended: function ended(e) {
	      var ele = e.path ? e.path[1] : e.target.parentElement;
	      ele.querySelector('a').className = constant.PAUSE_CLASS;
	    },
	    waiting: function waiting(e) {
	      var ele = e.path ? e.path[1] : e.target.parentElement;
	      ele.querySelector('a').className = constant.LOAD_CLASS;
	    },
	    error: function error(e) {
	      console.log(e);
	    }
	  }
	};

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _constant = __webpack_require__(1);
	
	var constant = _interopRequireWildcard(_constant);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	var currentTarget = void 0;
	exports.default = {
	  data: function data() {
	    return {
	      audios: []
	    };
	  },
	
	  props: {
	    source: {
	      type: String,
	      required: true,
	      validator: function validator(value) {
	        return value;
	      }
	    },
	    mode: {
	      type: Number,
	      default: constant.SINGLE
	    },
	    index: {
	      type: Number,
	      default: 0,
	      required: true
	    },
	    preload: {
	      type: String,
	      default: 'none',
	      validator: function validator(value) {
	        return value === 'none' || value === 'auto' || value === 'metadata';
	      }
	    },
	    autoplay: {
	      type: Boolean,
	      default: false
	    },
	    muted: {
	      type: Boolean,
	      default: false
	    }
	  },
	  mounted: function mounted() {
	    this.$nextTick(function () {
	      this.audios = document.getElementsByClassName('vue-audio');
	    });
	  },
	
	  computed: {
	    loop: function loop() {
	      return this.mode === constant.LOOP;
	    }
	  },
	  methods: {
	    startPlay: function startPlay(e) {
	      var target = e.currentTarget;
	      var audio = target.querySelector('audio');
	      if (audio.paused || audio.ended) {
	        audio.play();
	      } else {
	        audio.pause();
	      }
	    },
	    _timeupdate: function _timeupdate(e) {
	      this.$emit('timeupdate', e);
	    },
	    _playing: function _playing(e) {
	      this.$emit('playing', e);
	      var ele = e.path ? e.path[1] : e.target.parentElement;
	      this._stopOther(ele);
	    },
	    _pause: function _pause(e) {
	      this.$emit('pause', e);
	    },
	    _waiting: function _waiting(e) {
	      this.$emit('waiting', e);
	    },
	    _ended: function _ended(e) {
	      this.$emit('ended', e);
	      this._modeControl();
	    },
	    _error: function _error(e) {
	      this.$emit('error', e);
	    },
	    _modeControl: function _modeControl() {
	      if (this.mode === constant.SINGLE) {
	        return;
	      }
	      var index = this.index;
	      var nextIndex = void 0;
	
	      if (this.mode === constant.ORDER && index < this.audios.length - 1) {
	        nextIndex = index + 1;
	        this.audios[nextIndex].play();
	        return;
	      }
	
	      if (this.mode === constant.CIRCULATION) {
	        if (index === this.audios.length - 1) {
	          nextIndex = 0;
	        } else {
	          nextIndex = index + 1;
	        }
	        this.audios[nextIndex].play();
	        return;
	      }
	
	      if (this.mode === constant.RANDOM) {
	        nextIndex = Math.floor((this.audios.length - 1) * Math.random());
	        if (nextIndex >= index) {
	          nextIndex += 1;
	        }
	        this.audios[nextIndex].play();
	      }
	    },
	    _stopOther: function _stopOther(target) {
	      if (currentTarget && currentTarget !== target) {
	        var audio = currentTarget.querySelector('audio');
	        audio.pause();
	        audio.currentTime = 0;
	      }
	      currentTarget = target;
	    }
	  }
	};

/***/ }),
/* 5 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 6 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 7 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(5)
	__webpack_require__(6)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(3),
	  /* template */
	  __webpack_require__(10),
	  /* scopeId */
	  "data-v-2f0ab110",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(7)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(4),
	  /* template */
	  __webpack_require__(11),
	  /* scopeId */
	  "data-v-505a2eb6",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 10 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    attrs: {
	      "id": "app"
	    }
	  }, [_c('div', {
	    staticClass: "parameter"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.mode),
	      expression: "mode"
	    }],
	    attrs: {
	      "type": "radio",
	      "name": "single",
	      "id": "single"
	    },
	    domProps: {
	      "value": _vm.single_mode,
	      "checked": _vm._q(_vm.mode, _vm.single_mode)
	    },
	    on: {
	      "__c": function($event) {
	        _vm.mode = _vm.single_mode
	      }
	    }
	  }), _vm._v(" "), _c('label', {
	    attrs: {
	      "for": "single"
	    }
	  }, [_vm._v("single")]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.mode),
	      expression: "mode"
	    }],
	    attrs: {
	      "type": "radio",
	      "name": "loop",
	      "id": "loop"
	    },
	    domProps: {
	      "value": _vm.loop_mode,
	      "checked": _vm._q(_vm.mode, _vm.loop_mode)
	    },
	    on: {
	      "__c": function($event) {
	        _vm.mode = _vm.loop_mode
	      }
	    }
	  }), _vm._v(" "), _c('label', {
	    attrs: {
	      "for": "loop"
	    }
	  }, [_vm._v("loop")]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.mode),
	      expression: "mode"
	    }],
	    attrs: {
	      "type": "radio",
	      "name": "order",
	      "id": "order"
	    },
	    domProps: {
	      "value": _vm.order_mode,
	      "checked": _vm._q(_vm.mode, _vm.order_mode)
	    },
	    on: {
	      "__c": function($event) {
	        _vm.mode = _vm.order_mode
	      }
	    }
	  }), _vm._v(" "), _c('label', {
	    attrs: {
	      "for": "order"
	    }
	  }, [_vm._v("order")]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.mode),
	      expression: "mode"
	    }],
	    attrs: {
	      "type": "radio",
	      "name": "listing",
	      "id": "circulation"
	    },
	    domProps: {
	      "value": _vm.circulation_mode,
	      "checked": _vm._q(_vm.mode, _vm.circulation_mode)
	    },
	    on: {
	      "__c": function($event) {
	        _vm.mode = _vm.circulation_mode
	      }
	    }
	  }), _vm._v(" "), _c('label', {
	    attrs: {
	      "for": "circulation"
	    }
	  }, [_vm._v("circulation")]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.mode),
	      expression: "mode"
	    }],
	    attrs: {
	      "type": "radio",
	      "name": "random",
	      "id": "random"
	    },
	    domProps: {
	      "value": _vm.random_mode,
	      "checked": _vm._q(_vm.mode, _vm.random_mode)
	    },
	    on: {
	      "__c": function($event) {
	        _vm.mode = _vm.random_mode
	      }
	    }
	  }), _vm._v(" "), _c('label', {
	    attrs: {
	      "for": "random"
	    }
	  }, [_vm._v("random")])]), _vm._v(" "), _c('div', {
	    staticClass: "audio-container"
	  }, _vm._l((_vm.lists), function(list, index) {
	    return _c('vue-audio', {
	      key: index,
	      attrs: {
	        "source": list.source,
	        "index": index,
	        "mode": _vm.mode
	      },
	      on: {
	        "timeupdate": _vm.timeupdate,
	        "playing": _vm.playing,
	        "pause": _vm.pause,
	        "ended": _vm.ended,
	        "waiting": _vm.waiting,
	        "error": _vm.error
	      }
	    }, [_c('div', {
	      staticClass: "player"
	    }, [_c('svg', {
	      staticClass: "progress",
	      attrs: {
	        "width": _vm.svgOptions.width,
	        "height": _vm.svgOptions.height
	      }
	    }, [_c('path', {
	      attrs: {
	        "fill": _vm.svgOptions.fill,
	        "stroke": _vm.svgOptions.stroke,
	        "stroke-width": _vm.svgOptions.strokeWidth
	      }
	    })]), _vm._v(" "), _c('a', {
	      staticClass: "play",
	      attrs: {
	        "href": "javascript:void(0)"
	      }
	    })])])
	  }))])
	},staticRenderFns: []}

/***/ }),
/* 11 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "vue-audio-container",
	    on: {
	      "click": function($event) {
	        $event.stopPropagation();
	        $event.preventDefault();
	        _vm.startPlay($event)
	      }
	    }
	  }, [_vm._t("default"), _vm._v(" "), _c('audio', {
	    staticClass: "vue-audio",
	    attrs: {
	      "muted": _vm.muted,
	      "autoplay": _vm.autoplay,
	      "preload": _vm.preload,
	      "src": _vm.source,
	      "loop": _vm.loop
	    },
	    on: {
	      "ended": _vm._ended,
	      "playing": _vm._playing,
	      "pause": _vm._pause,
	      "error": _vm._error,
	      "timeupdate": _vm._timeupdate,
	      "waiting": _vm._waiting
	    }
	  })], 2)
	},staticRenderFns: []}

/***/ })
]);


// WEBPACK FOOTER //
// static/js/app.5d69289f08784937ebf3.js